import React from 'react';

const Tabs = ({ className, ...props }) => {
  return <div className={`${className || ''}`} {...props} />;
};

const TabsList = ({ className, ...props }) => {
  return (
    <div
      className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 text-gray-500 ${className || ''}`}
      {...props}
    />
  );
};

const TabsTrigger = ({ className, active, ...props }) => {
  return (
    <button
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${active ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-900'} ${className || ''}`}
      {...props}
    />
  );
};

const TabsContent = ({ className, value, selectedValue, ...props }) => {
  const isSelected = value === selectedValue;
  
  if (!isSelected) return null;
  
  return (
    <div
      className={`mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 ${className || ''}`}
      {...props}
    />
  );
};

export { Tabs, TabsList, TabsTrigger, TabsContent };
